import React from 'react';
import { Link } from 'react-router-dom';
import CookiePopup from '../components/CookiePopup';

const GuestFooter = () => {

    return (
        <>
            <footer className="w-full px-3 sm:px-5 min-h-[60px] py-3 flex flex-col sm:flex-row gap-2 sm:gap-4 justify-center items-center border-t border-custom-charcoal bg-custom-dark z-10">
                <p className="text-xs sm:text-xs text-white text-center sm:text-left">&copy; {new Date().getFullYear()} Oreca Pro</p>
                <div className="flex flex-wrap justify-center gap-2 sm:gap-4">
                    <Link to="/privacy-policy" className="text-[10px] sm:text-xs text-white hover:underline whitespace-nowrap">Privacy Policy</Link>
                    <Link to="/terms-and-conditions" className="text-[10px] sm:text-xs text-white hover:underline whitespace-nowrap">Terms & Conditions</Link>                    
                    <Link to="/cookie-policy" className="text-[10px] sm:text-xs text-white hover:underline whitespace-nowrap">Cookie Policy</Link>
                    <Link to="/support" className="text-[10px] sm:text-xs text-white hover:underline whitespace-nowrap">Support</Link>
                    <Link to="mailto:info@oreca.pro?subject=Enquiry from Oreca Pro Website" className="text-[10px] sm:text-xs text-white hover:underline whitespace-nowrap">info@oreca.pro</Link>
                </div>
            </footer>
            <CookiePopup onAccept={() => {}} />
        </>
    );
};

export default GuestFooter;
